/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/insurance_medium'
export default icon
